import React from 'react';
import { activitiesTypeObject } from '../utils/constants';
import ContentVisualizer from '../components/ContentVisualizer';
import { Divider } from '@mui/material';
import { Button } from '@mui/material';

import * as styles from './Activities.module.css';

const ActiveMethodologies = ({
  activeMethodologies,
  contentfulId,
  userId,
  skipPhone,
  passingSearch,
  isMobile,
  lesson,
}) => {
  const closedExercise =
    lesson.closedExercise?.childMarkdownRemark?.html ||
    lesson?.closedExerciseImages;

  let incrementActivities = closedExercise ? 3 : 2;

  return (
    <>
      {Array.isArray(activeMethodologies) &&
        activeMethodologies.length > 0 &&
        activeMethodologies.map((activeMethodology, index) => {
          if (
            !activeMethodology.activities ||
            activeMethodology.activities.length === 0
          ) {
            return null;
          }
          const supportMaterials =
            activeMethodology.activities[0]?.supportMaterials;
          const contextualization =
            activeMethodology.activities[0]?.contextualization;

          const activitieName =
            activitiesTypeObject[activeMethodology?.name?.toLowerCase()]
              ?.urlSlug;

          return (
            <li key={'methodology-index-' + index}>
              {activeMethodology.name && (
                <h3
                  className={styles.subtitleH3Activities}
                  id={`${activitieName}`}
                >
                  {index + incrementActivities}. {activeMethodology.name}:
                </h3>
              )}

              <div className={styles.flexWrapper}>
                {supportMaterials.map((material, index) => {
                  return (
                    <ContentVisualizer
                      contentfulId={contentfulId}
                      userId={userId}
                      key={'material-index-' + index}
                      asset={material}
                      lesson={lesson}
                      urlSlug={activitieName}
                    />
                  );
                })}
              </div>

              {contextualization && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: contextualization
                      .replaceAll('\n', '</p><p>')
                      .replace(/\\-/g, '-'),
                  }}
                />
              )}

              <Button
                href={`${
                  process.env.GATSBY_APP_BASE_URL
                }/aula/${contentfulId}/${
                  activitiesTypeObject[activeMethodology?.name?.toLowerCase()]
                    ?.urlSlug
                }?utm_origin=SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
                className="contained-btn btn-medium"
                style={{ marginTop: isMobile ? '20px' : '14px' }}
              >
                Atividade completa
              </Button>

              {activeMethodology.name && <Divider className="divider" />}
            </li>
          );
        })}
    </>
  );
};

export default ActiveMethodologies;
